
<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">

    <div class="grid-x grid-margin-x section">
      <div class="cell small-12 medium-12 large-12">
        <div class="checkbox">
          <view-notes [fieldName]="'confidentiality'" [notes]="getFilteredNotes('confidentiality')" (notesRequested)="handleNotesRequested($event)"></view-notes>

          <input class="show-for-sr" id="confidentiality" type="checkbox" formControlName="confidentiality" />
          <label for="confidentiality">
            Confidentiality:
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      </div>

      @if (!filesUploaded) {
        <div class="cell small-12 medium-12 large-12">
          <div class="checkbox">
            <view-notes [fieldName]="'logsRunCheck'" [notes]="getFilteredNotes('logsRunCheck')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            <input class="show-for-sr" id="logsRunCheck" type="checkbox" formControlName="logsRunCheck" />
            <label for="logsRunCheck" class="bold">
              No logs were run:
              <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
      }

      @if (filesUploaded) {
        <div class="cell">
          <div>
            <view-notes [fieldName]="'typeOfLog'" [notes]="getFilteredNotes('typeOfLog')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            <label for="typeOfLog">
              Type of Log Run
            </label>
            <input type="text" formControlName="typeOfLog" />
          </div>
          <div>
            <view-notes [fieldName]="'loggingCompany'" [notes]="getFilteredNotes('loggingCompany')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            <label for="loggingCompany">
              Name of Logging Company
            </label>
            <input type="text" formControlName="loggingCompany" />
          </div>
        </div>
      }

      <div class="grid-x grid-margin-x section">
        <div class="cell small-12 medium-12 large-12 bold padding-left">
          Download Files:
        </div>
        <div class="cell small-12 medium-12 large-12 padding-left">
          <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          <upload-view-files [uniqueId]="'uploadedFiles'" [files]="storedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="false" [allowUpload]="false">
          </upload-view-files>
        </div>
      </div>
    </div>
    <hr />
    <label for="receivedDate">Date Log was Received</label>
    <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate')?.disabled"></common-date-picker>

    <div class="grid-x grid-margin-x">
      <div class="large-12 medium-12 small-12 text-align-center">
        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onSave()">Save for Later</button>
          </span>
        }

        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onAccept()">Accept</button>
          </span>
        }

        <ng-container>
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onReturn()">Return For Corrections</button>
            </span>
          }
        </ng-container>
        <span>
          <button class="button" (click)="cancel()">Cancel</button>
        </span>
      </div>


    </div>



  </form>
</div>

